<p-card [class.proposal-section--valid]="completed">
  <h3 class="text-center" i18n>Plan d'assurance de {{ fullName }}</h3>

  <div class="flex flex-row align-items-center gap-3">
    <em-needs-reminder-section [needs]="needs" class="w-full"></em-needs-reminder-section>
    @if (_willRequireExtraRequirements && !wasExtraRequirementsNoticeClosed) {
      <div class="layout__inner-card bg-yellow-200 align-self-stretch">
        <div class="flex flex-row justify-content-between">
          <h4 i18n>Exigences médicales</h4>
          <span class="pi pi-times cursor-pointer h-fit" (click)="closeExtraRequirementsNotice()"></span>
        </div>
        <p i18n
          >Des exigences médicales seront commandées pour votre client en tarification, voir la grille de
          sélection pour plus de détails.</p
        >
      </div>
    }
  </div>

  <em-protection-builder
    [ratesVersion]="ratesVersion"
    [age]="age"
    [sex]="sex"
    [smoker]="smoker"
    [categoryCode]="categoryCode"
    [jobRiskClass]="jobRiskClass"
    (protectionBuilt)="onProtectionBuilt($event)"
    [prefilledCoverage]="prefilledCoverage"
    [withToasterAlerts]="true">
  </em-protection-builder>
</p-card>
